module.exports = __webpack_public_path__ + "static/media/uni-cc-04.224ad0e3.png";